module.exports = __webpack_public_path__ + "img/15.a8409108.webp";